import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchJournalEntry = async ({ limit, page, filters, sort, ret, ref, incl,useAggregate = false }) => {
  try {
    const [JournalEntryResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.WF_JOURNAL_ENTRY.GET_ALL,
        params: {
          coll: "JournalEntry",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
          useAggregate,
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.WF_JOURNAL_ENTRY.GET_TOTAL_COUNT,
        params: {
          coll: "JournalEntry",
          fil: JSON.stringify(filters),
        },
      }),
    ]);

    return {
      data: JournalEntryResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Fetch one JournalEntry by UIID
export const fetchOneJournalEntry = async ({ JournalEntryUiid, retrieve, ref, incl }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.WF_JOURNAL_ENTRY.GET_BY_UIID,
    params: {
      coll: "JournalEntry",
      ret: retrieve,
      ref: ref,
      fil: JSON.stringify({ uiid: { type: "NONE", value: JournalEntryUiid } }),
      incl,
    },
  });
};
export const addNewJournalEntry = async (JournalEntryData) => {
  return await axiosRequest({
    method: 'POST',
    url: ENDPOINTS.WF_JOURNAL_ENTRY.ADD_NEW,
    data: {
      coll: 'JournalEntry',
      payload: JournalEntryData,
    },
  });
};
export const updateJournalEntry = async ({ coll, uiid, payload, patchId, tPath }) => {
  const params = {
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: 'PATCH',
    url: ENDPOINTS.WF_JOURNAL_ENTRY.UPDATE,
    data: { payload },
    params,
  });
};

// Banking Message Chat APIs
export const fetchBankingMessages = async ({ limit = 100, page = 1, filters, sort, ret, ref, incl, useAggregate = false }) => {
  try {
    const [response] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.WF_OFFTRX_MESSAGES.GET_ALL,
        params: {
          coll: "BankingMessage",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          cache: false,
          sort: JSON.stringify(sort),
          ret,
          ref,
          incl,
          useAggregate,
        },
      }),
      // axiosRequest({
      //   method: "GET",
      //   url: ENDPOINTS.WF_OFFTRX_MESSAGES.GET_TOTAL_COUNT,
      //   params: {
      //     coll: "BankingMessage",
      //     fil: JSON.stringify(filters),
      //   },
      // }),
    ]);

    return {
      data: response.data,
      // totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const addNewBankingMessage = async (messageData) => {
  return await axiosRequest({
    method: 'POST',
    url: ENDPOINTS.WF_OFFTRX_MESSAGES.ADD_NEW,
    data: {
      coll: 'BankingMessage',
      payload: messageData,
    },
  });
};

export const updateBankingMessage = async ({ uiid, payload, filters }) => {
  return await axiosRequest({
    method: 'PATCH',
    url: ENDPOINTS.WF_OFFTRX_MESSAGES.UPDATE,
    data: { payload },
    params: {
      coll: 'BankingMessage',
      ...(uiid && { uiid }),
      fil: JSON.stringify(filters),
    },
  });
};
